<template>
  <section class="wrapper">
    <aside class="approval-item" v-for="(item,i) in approvalList" :key="i" @click="selectApprovalItem(item)">
      <div class="date">发起日期：{{item.CreateDate}}</div>
      <van-divider :style="{ borderColor: '#f2f2f2',margin:'1rem' }"/>
      <van-row class="title">
        <van-col span="12">{{formTypeHandle(item.FormType)}}</van-col>
        <van-col span="12" class="text-right">停留时间：<span class="h6 mr5">{{item.State=='3'?'-':formatMinutes(item.RetentionMin)}}</span></van-col>
      </van-row>
      <div class="summary">单号:{{item.FormNo}}</div>
      <div class="summary">摘要:{{item.Remark}}</div>
      <div class="summary">我的身份:{{item.IsAddFlag==true||item.IsAddFlag==1?"被加签":"审批人"}}</div>
      <van-divider :style="{ borderColor: '#f2f2f2',margin:'1rem' }" hairline/>
      <div class="user-name">发起人:{{item.ApplyName}}</div>
    </aside>
  </section>
</template>

<script>
  import {getApprovalListApi} from '@/api/reimbursement'

  export default {
    data() {
      return {
        approvalList: []
      }
    },
    mounted() {
      //清除跳转保存的参数信息
      // this.removeCookie("ApproveDetail");
      this.getApprovalList();
    },
    methods: {
      //显示审批业务类型
      formTypeHandle(value) {
        let name=value;
        switch (value) {
          case "FK":
            name = "付款申请";
            break;
          case "FC":
            name = "公司信息变更";
            break;
          case "FH":
            name = "员工薪酬表申请";
            break;
          case "FI":
            name = "借款/预付款申请";
            break;
          case "FS":
            name = "销售合同批准";
            break;
          case "FO":
            name = "客户订单确认";
            break;
          case "FA":
            name = "采购合同申请";
            break;
          case "FD":
            name = "采购订单申请";
            break;
          case "FJ":
            name = "组织架构申请";
            break;
          case "FB":
            name = "报销申请";
            break;
          case "FL":
            name = "请假申请";
            break;
          case "FT":
            name = "出差申请";
            break;
          case "FW":
            name = "加班申请";
            break;
          case "发货申请":
            name = "发货申请";
            break;
          case "生产确认":
            name = "生产确认";
            break;
          case "FF":
            name = "入职申请";
            break;
          case "FG":
            name = "离职申请";
            break;
          case "FN":
            name="费用申请";
            break;
          case "FBP":
            name="新增客户";
            break;
          case "FBX":
            name="分配客户";
            break;
          case "HF":
            name="录用申请";
            break;
          case "FZ":
            name="通用申请";
            break;
          default:
            name = value;
            break;
        }
        return name;
      },
      //逗留时间转换格式
      formatMinutes(minutes) {
        let day = parseInt(Math.floor(minutes / 1440));
        let hour = day > 0 ? Math.floor((minutes - day * 1440) / 60) : Math.floor(minutes / 60);
        let minute = Math.floor(minutes - day * 1440 - hour * 60);
        let time = "";
        if (day > 0) time += day + "天";
        if (hour > 0) time += hour + "小时";
        if (minute > 0) time += minute + "分钟";
        return time;
      },
      //获取待审批列表
      async getApprovalList() {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          formType: "",
          cGuid: companyInfo.companyId,
          uGuid: userInfo.U_GUID,
          applyUGuid: ""
        };
        let response = await getApprovalListApi(params);
        if (response.success) {
          this.approvalList = response.result
        }
      },
      //选择待审批数据
      selectApprovalItem(item) {
        this.$router.push({
          path: '/approval/detail', query: {
            guid: item.Approval_GUID
          }
        });
      }
    }
  }
</script>

<style lang="less" scoped>
  .approval-item {
    background: white;
    margin: 1rem;
    padding: 1rem;

    .date {
      color: #9c9c9c;
    }

    .title {
      color: #323332;
      font-size: 1.6rem;
    }

    .summary {
      color: #333333;
      margin-top: 1rem;
      font-size: 1.6rem;
    }
    .user-name {
      font-size: 1.6rem;
    }
  }
</style>
